define('view/disclosure/disclosure.modals',['require','exports','module','view/disclosure/modals/reason.for.modification.modal'],function(require, exports, module) {
  //prettier-ignore
  var ReasonForModificationModal    = require('view/disclosure/modals/reason.for.modification.modal');

  var DisclosureModals = {
    //Modals
    reasonForModificationModal: {
      type: ReasonForModificationModal,
    },
  };

  module.exports = DisclosureModals;
});

